import { render, staticRenderFns } from "./OnboardV2.vue?vue&type=template&id=5bc43f99&scoped=true"
import script from "./OnboardV2.vue?vue&type=script&lang=js"
export * from "./OnboardV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc43f99",
  null
  
)

export default component.exports